// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"368":"5a988dd7d0e2541a","584":"adc45276393c91f2"}[chunkId] + ".js";
};